module.exports = __webpack_public_path__ + "img/8.637aa749.jpg";